<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>A Canadian Girl in South Africa</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="chaptitle-pre">Contents</p>
<p class="toc0"><a id="page_v"></a><a href="#/06_Acknowledgements"><em class="italic">Acknowledgements</em></a></p>
<p class="toc1"><a href="#/08_Introduction"><em class="italic">Introduction</em></a></p>
<p class="toc2"><span href="#/09_A_Africa" title="Link target outside of Sample">A CANADIAN GIRL IN SOUTH AFRICA</span></p>
<p class="toc"><span href="#/14_Chapter_01" title="Link target outside of Sample">CHAPTER I | The Call to South Africa</span></p>
<p class="toc"><span href="#/15_Chapter_02" title="Link target outside of Sample">CHAPTER II | London</span></p>
<p class="toc"><span href="#/16_Chapter_03" title="Link target outside of Sample">CHAPTER III | Southampton to Cape Town</span></p>
<p class="toc"><span href="#/17_Chapter_04" title="Link target outside of Sample">CHAPTER IV | On the Karoo</span></p>
<p class="toc"><span href="#/18_Chapter_05" title="Link target outside of Sample">CHAPTER V | Norval’s Pont Camp</span></p>
<p class="toc"><span href="#/19_Chapter_06" title="Link target outside of Sample">CHAPTER VI | Johannesburg and Pretoria</span></p>
<p class="toc"><span href="#/20_Chapter_07" title="Link target outside of Sample">CHAPTER VII | End of the Camp Life</span></p>
<p class="toc"><span href="#/21_Chapter_08" title="Link target outside of Sample">CHAPTER VIII | Fauresmith</span></p>
<p class="toc"><span href="#/22_Chapter_09" title="Link target outside of Sample">CHAPTER IX | Kroonstad</span></p>
<p class="toc"><span href="#/23_Chapter_10" title="Link target outside of Sample">CHAPTER X | The Kafirs and the Labor Question</span></p>
<p class="toc"><span href="#/24_Chapter_11" title="Link target outside of Sample">CHAPTER XI | Repatriation and Compensation</span></p>
<p class="toc"><span href="#/25_Chapter_12" title="Link target outside of Sample">CHAPTER XII | Paupers and Government Relief Works</span></p>
<p class="toc"><span href="#/26_Chapter_13" title="Link target outside of Sample">CHAPTER XIII | Education and Church Schools</span></p>
<p class="toc"><span href="#/27_Chapter_14" title="Link target outside of Sample">CHAPTER XIV | The Farming Question</span></p>
<p class="toc"><span href="#/28_Chapter_15" title="Link target outside of Sample">CHAPTER XV | Homewards</span></p>
<p class="toc1a"><span href="#/29_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></p>
<p class="toc1"><span href="#/30_Index" title="Link target outside of Sample"><em class="italic">Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?a3db87c8